import { z } from 'zod'

import { phoneNumber } from '~/lib'

export const officeContactFormSchema = z.object({
  name: z.string().max(60),
  organization: z.string().max(50),
  email: z.string().max(254).email(),
  phone: phoneNumber(z.string()),
  numberOfPeople: z.string().optional(),
  desiredMoveInDate: z.string().optional(),
  budget: z.string().optional(),
  content: z.string().max(2000).optional(),
  agree: z.boolean({
    errorMap: () => ({
      message: '利用規約・プライバシーポリシーに同意してください',
    }),
  }),
})

export type OfficeContactFormType = z.infer<typeof officeContactFormSchema>
